export default __webpack_public_path__ + "static/media/BWP ZOO WEB ICON aviary CY.87a48512.png";